module.exports = __webpack_public_path__ + "img/product-management.386d4528.svg";